'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cookieRemove = exports.cookieSet = exports.cookieCheck = undefined;

var _componentCookie = require('component-cookie');

var _componentCookie2 = _interopRequireDefault(_componentCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cookieCheck = exports.cookieCheck = function cookieCheck(cookieMaxAge, cookieName) {
  return !((0, _componentCookie2.default)(cookieName) || isNaN(parseInt(cookieMaxAge, 10)) || cookieName.length === 0);
};
var cookieSet = exports.cookieSet = function cookieSet(cookieName, cookieMaxAge) {
  return (0, _componentCookie2.default)(cookieName, 'true', { maxage: cookieMaxAge * 86400000, path: '/' });
};
var cookieRemove = exports.cookieRemove = function cookieRemove(cookieControlled, cookieName) {
  return !cookieControlled && (0, _componentCookie2.default)(cookieName) && (0, _componentCookie2.default)(cookieName, null, { path: '/' });
};